/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = window.Theme?.routes?.cart_url || '/cart';
      }
    },
  });

    // Nothing else in the theme calls `Shopify.actions.openCart`, so the
      // drawer never opened after a successful add. Listen for the standard
        // cart-lines-update event (dispatched on every add-to-cart submission)
          // and trigger it ourselves.
            document.addEventListener('shopify:cart:lines-update', () => {
                actions.openCart();
                  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`. Module scripts execute after the document has been
// parsed, so `DOMContentLoaded` may already have fired by the time this
// script runs - listening for it alone can miss the event entirely.
// Poll instead until `Shopify.actions` becomes available, since the
// external bundle can attach after this script has already run.
function waitForActions() {
  if (window.Shopify?.actions) {
  init();
  } else {
  setTimeout(waitForActions, 50);
}
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', waitForActions, { once: true });
} else {
waitForActions();
}
